import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

/**
 * Grants access to reviewers (has_role reviewer) OR admins.
 */
export function ProtectedReviewerRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const [ok, setOk] = useState<boolean | null>(null);

  useEffect(() => {
    (async () => {
      if (loading) return;
      if (!user) {
        setOk(false);
        return;
      }
      try {
        const [{ data: rev }, { data: adm }] = await Promise.all([
          supabase.rpc("has_role", { _user_id: user.id, _role: "reviewer" as any }),
          supabase.rpc("is_admin", { _user_id: user.id }),
        ]);
        setOk(Boolean(rev) || Boolean(adm));
      } catch (e) {
        console.error("[ReviewerGuard]", e);
        setOk(false);
      }
    })();
  }, [user, loading]);

  if (loading || ok === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!ok) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
